<template>
  <div class="col-12 page_content_area">
    <div class="container enterprises_content_area">
      <intern-form :hidden="isEmpty" edit-type="view" :form-title="formTitle" :form-type="formType" :blueprint="blueprint"
        :backPath="`/teachers/intern-record/${this.$route.params.year}/${this.$route.params.eid}/${this.$route.params.sid}`"
        @load="load" @downloadPdf="downloadPdf" @printPdf="printPdf" />
      <iframe id="print" style="display: none;"></iframe>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import InternForm from '~components/common/forms/InternForm'
import { InternSatisfactionBlueprint } from '~components/common/forms/blueprints/InternSatisfaction.js'
import { InternSatisfactionFormFormat } from '~components/common/forms/form_format/InternSatisfaction.js'
import {
  blueprint_form_data_to_str_form_data,
  create_new_window_cnt,
  create_pdf_data_url,
} from '~components/common/forms/blueprint_form_pdf.js'
import { downloadPdf } from '~api/pdf'
import { getDeptOptions, getYearOptions } from '~components/common/forms/UniversalOptions.js'
export default {
  name: 'TeacherInternSatisfactionContent',
  components: {
    InternForm,
  },
  props: {
  },
  computed: {
    ...mapGetters('pages/teachers', [
      'currentInternFormGetter',
    ]),
    blueprint() {
      return InternSatisfactionBlueprint;
    }
  },
  data() {
    return {
      formTitle: '實習機構滿意度調查',
      formType: 'intern_satisfaction',
      isEmpty: true,
      dept: {},
    };
  },
  methods: {
    ...mapActions('layouts', [
      'togglePageLoader'
    ]),
    ...mapActions('pages/teachers', [
      'getInternForm',
    ]),
    async load(enter_area) {
      this.togglePageLoader(true);
      await this.setEnterBlockOptions(enter_area);
      await this.getInternForm({
        type: this.formType,
        params: {
          year: this.$route.params.year,
          enterprise_id: this.$route.params.eid,
          student_id: this.$route.params.sid,
        }
      });

      if (Object.keys(this.currentInternFormGetter).length) {
        this.isEmpty = false;
        if (this.currentInternFormGetter.lang == 'en') {
          this.$router.push({ path: `/teachers/intern-record/${this.$route.params.year}/${this.$route.params.eid}/${this.$route.params.sid}/intern-satisfaction-en` });
        }
        enter_area.set_form_data(this.currentInternFormGetter);
      }
      this.togglePageLoader(false);
    },
    async setEnterBlockOptions(enter_area) {
      let { dept_options, dept_values } = await getDeptOptions();
      enter_area.set_enter_block_options('department_id', dept_options, dept_values);
      this.dept = { dept_options, dept_values };
    },
    get_form_sq(blueprint) {
      let form_data = { ...this.currentInternFormGetter };
      blueprint.filter(enter_block => enter_block.key == 'department_id').forEach(enter_block => {
        enter_block.options = this.dept.dept_options;
        enter_block.values = this.dept.dept_values;
      });
      blueprint_form_data_to_str_form_data(blueprint, form_data);
      return InternSatisfactionFormFormat(blueprint, form_data);
    },
    async downloadPdf() {
      let blueprint = JSON.parse(JSON.stringify(InternSatisfactionBlueprint));
      let { header_sq, content_sq } = this.get_form_sq(blueprint);
      let pdf_data_url = create_pdf_data_url(3, header_sq, content_sq);
      let el = document.createElement('a');
      el.href = pdf_data_url;
      el.download = `${this.formTitle}.pdf`;
      document.body.appendChild(el);
      el.click();
    },
    async printPdf() {
      let blueprint = JSON.parse(JSON.stringify(InternSatisfactionBlueprint));
      let { header_sq, content_sq } = this.get_form_sq(blueprint);
      let new_window_cnt = create_new_window_cnt(3, header_sq, content_sq);
      let new_window = window.open('_blank','','width=841,height=1189');
      new_window.document.write('<body onload="print(); close()">');
      new_window.document.write(new_window_cnt);
      new_window.document.write('</body>');
      new_window.document.close();
    },
  }
}
</script>
<style lang="scss" scoped>
#lang_btn {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  display: flex;
  align-items: center;
}
</style>
